// src/utils/logger.ts

/**
 * 開発環境でのみログを出力するLogger
 */

const IS_DEV = process.env.NODE_ENV === 'development';

export const logger = {
  /**
   * デバッグログ（開発環境のみ）
   */
  debug: (...args: any[]) => {
    if (IS_DEV) {
      console.log(...args);
    }
  },

  /**
   * 情報ログ（常に出力）
   */
  info: (...args: any[]) => {
    console.log(...args);
  },

  /**
   * 警告ログ（常に出力）
   */
  warn: (...args: any[]) => {
    console.warn(...args);
  },

  /**
   * エラーログ（常に出力）
   */
  error: (...args: any[]) => {
    console.error(...args);
  },

  /**
   * グループ開始（開発環境のみ）
   */
  group: (label: string) => {
    if (IS_DEV) {
      console.group(label);
    }
  },

  /**
   * グループ終了（開発環境のみ）
   */
  groupEnd: () => {
    if (IS_DEV) {
      console.groupEnd();
    }
  }
};
